import { render, staticRenderFns } from "./AdminPagination.vue?vue&type=template&id=60be0a11&"
import script from "./AdminPagination.vue?vue&type=script&lang=ts&"
export * from "./AdminPagination.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VIcon,VPagination})
